import {Mapper} from '@s-ui/domain'

export default class FromDoorsSearchUrlParamToSearchCodeValueObjectMapper extends Mapper {
  constructor({valueObject}) {
    super()
    this._valueObject = valueObject
  }

  _parseDoorsSearchUrlParam = ({searchUrlParam} = {}) => {
    const DOORS_REGEX = /(?<doors>\d)*(-puertas)/
    const matchedParts = searchUrlParam.match(DOORS_REGEX)
    const {doors} = matchedParts?.groups || {}

    return Number(doors)
  }

  map = ({searchUrlParam}) => {
    const searchCode = this._parseDoorsSearchUrlParam({searchUrlParam})
    return this._valueObject({searchCode})
  }
}
